// @flow
import styled from "styled-components";

export const Expander = styled.div`
	padding: 5%;
`;

export default Expander;


// WEBPACK FOOTER //
// ./src/components/Draft/Expander.js